module.exports = __webpack_public_path__ + "static/media/defaultMap.4ef7d5d5.png";